import { render, staticRenderFns } from "./base-input-select.vue?vue&type=template&id=59b7dbe9&scoped=true&"
import script from "./base-input-select.vue?vue&type=script&lang=js&"
export * from "./base-input-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b7dbe9",
  null
  
)

export default component.exports